import React, { Component } from "react";
import { Avatar } from "@material-ui/core";

class AccountAvatar extends Component {
  render() {
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{ position: "relative", display: "inline", float: "left" }}
          >
            <Avatar
              style={{
                height: 36,
                width: 36,
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "rgb(39, 174, 96)",
                backgroundColor: "rgb(39, 174, 96,0.1)"
              }}
            >
              VG
            </Avatar>
            <div
              style={{
                position: "absolute",
                right: 0,
                bottom: 0,
                width: 13,
                height: 13,
                background: "rgb(39, 174, 96)",
                border: "2px solid #fff",
                borderRadius: 100
              }}
            />
          </div>
          <div style={{ display: "inline", float: "left", marginLeft: 10 }}>
            Vince Gabriel Lagarto
          </div>
        </div>
      </div>
    );
  }
}

export default AccountAvatar;
